/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ShuffleSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674L188,79.314l-31.71582,31.71583a8.00035,8.00035,0,0,1-11.31445-11.314L176.68579,68l-14.343-14.34326A8.00038,8.00038,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48Zm-4.93848,112.60889a8.00113,8.00113,0,0,0-8.71875,1.73437L188,176.686,53.65723,42.34326A8.00018,8.00018,0,1,0,42.34277,53.65674L176.686,188l-14.34327,14.34326A8.00038,8.00038,0,0,0,168,216h40a8.00008,8.00008,0,0,0,8-8V168A8.00015,8.00015,0,0,0,211.06152,160.60889ZM99.71582,144.97021l-57.373,57.373a8.00018,8.00018,0,0,0,11.31446,11.31348l57.373-57.37256a8.00035,8.00035,0,0,0-11.31445-11.314Z" />
    </Svg>
  );
}

export default ShuffleSimple;
